import { useRef, useEffect } from 'react'
import iframeResizer from 'iframe-resizer'

import { creditCardFormStateSelector } from '../../selectors'

const CreditCardForm = ({ selectedBrand, iframeName }) => {
    const iframeRef = useRef(null)

    useEffect(() => {
        const allowedOrigins = [location.origin, 'https://ogone.test.v-psp.com', 'https://secure.ogone.com']

        if (iframeRef.current) {
            iframeResizer({ log: false, checkOrigin: allowedOrigins }, iframeRef.current)
        }
    }, [])

    return (
        <iframe
            ref={iframeRef}
            name={iframeName}
            sandbox="allow-forms allow-same-origin allow-scripts"
            style={{ display: selectedBrand ? 'block' : 'none' }}
        />
    )
}

export default connect(creditCardFormStateSelector)(CreditCardForm)
